export default "__VITE_ASSET__DJrOzRg3__"